import { render, staticRenderFns } from "./ConversationTalentInfo.vue?vue&type=template&id=23a032c4&scoped=true&"
import script from "./ConversationTalentInfo.vue?vue&type=script&lang=ts&"
export * from "./ConversationTalentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationTalentInfo.vue?vue&type=style&index=0&id=23a032c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a032c4",
  null
  
)

/* custom blocks */
import block0 from "./ConversationTalentInfo.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5CConversationTalentInfo.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VRating})
